
    import '/opt/buildhome/repo/packages/x/components/x-request/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["components-x-request-demo-basic","components-x-request-demo-requestparams","components-x-request-demo-custom-transformer","components-x-request-demo-request-options","components-x-request-demo-model"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/x-request/index.en-US.md?type=demo')
};